import classNames from 'classnames';
import React, { FunctionComponent } from 'react';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../../utils/rebrand';
import defaultStyles from './TicketName.module.scss';
import rebrandStyles from './TicketName.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

export interface TicketNameProps {
    className?: Parameters<typeof classNames>[0];
    disabled?: boolean;
    isAppRebrandActive?: boolean;
}

const TicketName: FunctionComponent<TicketNameProps> = ({
    children,
    className,
    disabled = false,
    isAppRebrandActive = false,
}) => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];

    return (
        <div
            className={classNames(
                styles.default,
                'eds-text-weight--heavy',
                {
                    'eds-text-bm': !isAppRebrandActive,
                    'eds-text-color--ui-600': !isAppRebrandActive && disabled,
                    'eds-text-color--ui-800': !isAppRebrandActive && !disabled,
                    [styles.disabled]: isAppRebrandActive && disabled,
                },
                className,
            )}
            data-testid="ticket-name-wrapper"
        >
            {children}
        </div>
    );
};

export default TicketName;
